// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in scamalyzer.js.

import appInit from './angle/app.init.js';
document.addEventListener('DOMContentLoaded', appInit);

require("./scamalyzer_ujs");

const modal = document.createElement('div');
modal.id = 'loading-modal';
modal.style.position = 'fixed';
modal.style.top = 0;
modal.style.left = 0;
modal.style.width = '100vw';
modal.style.height = '100vh';
modal.style.background = 'rgba(65, 185, 201, 0.5)';
modal.style.display = 'flex';
modal.style.alignItems = 'center';
modal.style.justifyContent = 'center';
modal.style.zIndex = 9999;
modal.innerHTML = `<div style="background:#fff;padding:2em 3em;border-radius:8px;font-size:1.2em;">Loading the Ring...</div>`;
modal.style.display = 'none';
document.body.appendChild(modal);

function showLoadingModal() {
    const modal = document.getElementById('loading-modal');
    if (modal) modal.style.display = 'flex';
}

function hideLoadingModal() {
    const modal = document.getElementById('loading-modal');
    if (modal) modal.style.display = 'none';
}

$(document).on('unload', 'form', function() {
    const modal = document.getElementById('loading-modal');
    if (modal) modal.style.display = 'none';
});